import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Tooltip from 'react-tooltip';
import { TextInputField, DEFAULT_REQUIRED_MESSAGE }  from 'common/components/form_fields';
import AnimatedButton from 'common/components/animated_button';
import FriendsField from 'marketing/components/friends_field';
import { isMobile } from 'common/utils';

const ReferAFriendForm = ({ error, handleSubmit, submitting, submitFailed, referrals }) => (
  <form onSubmit={handleSubmit} noValidate>
    <fieldset>
      <h3>We'll tell your friend(s) you helped them.</h3>
      <Field name="client_name" label="Enter your first and last name" component={TextInputField} />
    </fieldset>

    <fieldset>
      <h3>Invite your friend(s) now...</h3>
      <p>
        So far, you've referred <span data-tip={referrals.length > 0}
        data-for="referral_count_tooltip" data-event={isMobile()? "click" : undefined}
        className="referral-count">{ referrals.length }</span> friends.
        We will not share these emails with anyone.
      </p>

      { referrals.length > 0 &&
      <Tooltip class="tooltip" effect="solid" place="right" id="referral_count_tooltip">
        { referrals.map((referral) => (
        <div className="referral" key={referral.id}>{ referral.to_email }</div>
        )) }
      </Tooltip> }

      <Field name="emails" component={FriendsField} />
    </fieldset>

    <AnimatedButton processing={submitting} type="submit" label="Send invite"
      processingLabel="Sending..." errorMsg={error || submitFailed}
      successMsg="Done!"/>
  </form>
)


const validate = values => {
  const errors = {}

  if (!values.client_name) {
    errors.client_name = DEFAULT_REQUIRED_MESSAGE;
  }

  if (!values.emails || values.emails.length === 0) {
    errors.emails = "Please add at least one email";
  }

  return errors
}

export default reduxForm({
  form: "ReferAFriendForm",
  validate,
})(ReferAFriendForm);



// WEBPACK FOOTER //
// ./marketing/components/refer_a_friend_form.jsx